import Vue from 'vue';
import Vuex from 'vuex';
import api from './api.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    signin_dialog: false,
  },

  mutations: {
    show_signin_dialog(state, val) {
      state.signin_dialog = val;
    },
  },

  getters: {
    signin_dialog: (state, getters) => state.signin_dialog,
  },
  actions: {
    api_suggest: (context, payload) => new Promise((resolve, reject) => {
      api.get_suggestion(payload.service, payload.q).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    }),

    api_get: (context, payload) => new Promise((resolve, reject) => {
      api.get_item(payload.service, payload.id).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        reject(err);
      });
    })
    ,
  },
});
